var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadUneven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74353 14.3986C2.41882 13.0739 2.41882 10.9261 3.74353 9.6014L9.6014 3.74353C10.9261 2.41882 13.0739 2.41882 14.3986 3.74353L20.2565 9.6014C21.5812 10.9261 21.5812 13.0739 20.2565 14.3986L14.3986 20.2565C13.0739 21.5812 10.9261 21.5812 9.6014 20.2565L3.74353 14.3986Z",
    stroke: "#2B323B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4383 11.0051C11.5064 11.2727 11.7239 11.5 12 11.5C12.2761 11.5 12.4936 11.2727 12.5617 11.0051C12.782 10.1399 13.5663 9.5 14.5 9.5C15.4337 9.5 16.218 10.1399 16.4383 11.0051C16.5064 11.2727 16.7239 11.5 17 11.5H17.5C17.7761 11.5 18 11.7239 18 12V13C18 13.2761 17.7761 13.5 17.5 13.5H14.5H9.5H6.5C6.22386 13.5 6 13.2761 6 13V12C6 11.7239 6.22386 11.5 6.5 11.5H7C7.27614 11.5 7.49359 11.2727 7.56171 11.0051C7.78197 10.1399 8.56626 9.5 9.5 9.5C10.4337 9.5 11.218 10.1399 11.4383 11.0051Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadUneven);
export default __webpack_public_path__ + "static/media/road-uneven.dc608112d5ab773d0e24cf7ab1322ca3.svg";
export { ForwardRef as ReactComponent };